import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/subtopic4/Actividad_Caja_V2.glb";
import { GUI } from "dat.gui";

export class ProductsPAR extends Mesh {
	constructor(camera, loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);

		let dracoloader = new DRACOLoader();
		this.camera = camera;
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		this.position.set(1.4138, 0.3295, 0.8431);
		this.observerListtneners();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Botella_1 = gltf.scene.getObjectByName("Botella_1", true);
			this.Dinero_1 = gltf.scene.getObjectByName("Dinero_1", true);
			this.Cigarros = gltf.scene.getObjectByName("Cigarros", true);
			this.Celular = gltf.scene.getObjectByName("Celular", true);
			// this.helpers();
		});
	}

	observerListtneners() { }

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("productos");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		// premiaFolder.open();
	}

	helpersChild() {
		this.helpersMethod("Botella_1", this.Botella_1);
		this.helpersMethod("Dinero_1", this.Dinero_1);
		this.helpersMethod("Cigarros", this.Cigarros);
		this.helpersMethod("Celular", this.Celular);
	}

	helpersMethod(name = "", object) {
		const { scale, position, rotation, material } = object;
		const gui = new GUI();
		const folderMostrador = gui.addFolder(name);
		const limit = 500;
		folderMostrador.add(scale, "x", -limit, limit).step(0.0001).name("Scala x");
		folderMostrador.add(scale, "y", -limit, limit).step(0.0001).name("Scala y");
		folderMostrador.add(scale, "z", -limit, limit).step(0.0001).name("Scala Z");

		folderMostrador.add(position, "x", -limit, limit).step(0.0001).name("Posición X");
		folderMostrador.add(position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folderMostrador.add(position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folderMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folderMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folderMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folderMostrador.add(object, "visible").name("Visible");

		folderMostrador
			.addColor({ color: material.color.getHex() }, "color")
			.name("Color del Material")
			.onChange((value) => {
				material.color.set(value);
			});

		folderMostrador.add({ loadTexture: () => this.loadNewTexture(object) }, "loadTexture").name("Cargar Textura");

		folderMostrador.add(object.material, "lightMapIntensity", 0, 5).name("Intensidad del mapa de luz");
		folderMostrador.add(object.material, "emissiveIntensity", 0, 5).name("Emesidad del mapa de luz");
		folderMostrador.add(object.material.map.repeat, "x", -5, 5).step(0.01).name("Repetición X");
		folderMostrador.add(object.material.map.repeat, "y", -5, 5).step(0.01).name("Repetición Y");
	}

	renderAnimations() { }
}
